export const verifyCreditCard = (restaurant) => {
    if(!restaurant.settings) return false
    if (restaurant.settings.payment_credit_card_visa) return true
    else if (restaurant.settings.payment_credit_card_mastercard) return true
    else if (restaurant.settings.payment_credit_card_maestro) return true
    else if (restaurant.settings.payment_credit_card_alelo) return true
    else if (restaurant.settings.payment_credit_card_american_express) return true
    else if (restaurant.settings.payment_credit_card_elo) return true
    else if (restaurant.settings.payment_credit_card_hipercard) return true
    else if (restaurant.settings.payment_credit_card_diners) return true
    else return false
}

export const verifyDebitCards = (restaurant) => {
    if(!restaurant.settings) return false
    if (restaurant.settings.payment_debit_card_visa) return true
    else if (restaurant.settings.payment_debit_card_mastercard) return true
    else if (restaurant.settings.payment_debit_card_maestro) return true
    else if (restaurant.settings.payment_debit_card_alelo) return true
    else if (restaurant.settings.payment_debit_card_american_express) return true
    else if (restaurant.settings.payment_debit_card_elo) return true
    else if (restaurant.settings.payment_debit_card_hipercard) return true
    else if (restaurant.settings.payment_debit_card_diners) return true
    else return false
  }
